// extracted by mini-css-extract-plugin
export default {"container":"error-page_container__JMveS","title":"error-page_title__+eysK","img":"error-page_img__shkBh"};